import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';
import { filter } from 'rxjs/operators';
import * as _ from 'lodash';
import { User } from '@common/models/User';
import { CommonService } from '@common/services/common.service';
import { CqrsService } from '@common/services/cqrs.service';
import { AdministrationPermissions, VesselVisitDocumentPermissions } from '@common/classes/permissions';
import { VesselVisitDocumentStatusCodes } from '@common/classes/vessel-visit-document-status-codes';
import { VesselVisitDocumentTypeCodes } from '@common/classes/vessel-visit-document-types';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { VesselVisitDocumentEditableCheckService } from '@common/services/vessel-visit-document-editable-check-service';
import { VesselVisitEditableCheckService } from '@common/services/vessel-visit-editable-check-service';

@Injectable({
    providedIn: 'root'
})
export class CanEditGuard implements CanActivate, CanActivateChild {
    private currentUser: User;
    protected cqrs: CqrsService;
    protected toastrService: ToastrService;
    protected translateService: TranslateService;
    protected vesselVisitEditableCheckService: VesselVisitEditableCheckService
    protected vesselVisitDocumentEditableCheckService: VesselVisitDocumentEditableCheckService

    constructor(
        private userService: UserService, 
        private router: Router,
        protected common: CommonService) 
{
        this.cqrs = common.cqrs;
        this.toastrService = common.toastrService;
        this.translateService = common.translateService;
        this.vesselVisitEditableCheckService = common.vesselVisitEditableCheckService;
        this.vesselVisitDocumentEditableCheckService = common.vesselVisitDocumentEditableCheckService;
        userService.currentUserSubject.subscribe((user) => this.currentUser = user);
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.paramMap.get('id');

        const isVesselVisit = state.url.includes('/vessel-visit/');
        const isVesselVisitDocument = state.url.includes('/vessel-visit-document/');

        var result = true;

        if (isVesselVisitDocument) {        
            result = await this.vesselVisitDocumentEditableCheckService.canEdit(id, this.currentUser);
        }else if(isVesselVisit) {
            result = await this.vesselVisitEditableCheckService.canEdit(id, this.currentUser);
        }

        console.log(`caneditguard, result=${result}`);

        return result;
    }    

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(childRoute, state);
    }       
}
